import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface LegalPageLayoutProps {
  titleKey: string;
  children: ReactNode;
}

export function LegalPageLayout({ titleKey, children }: Readonly<LegalPageLayoutProps>) {
  const { t } = useTranslation();

  const handleBack = () => {
    globalThis.location.hash = '';
  };

  return (
    <article className="mx-auto max-w-3xl px-4 py-6">
      <Button variant="ghost" size="sm" onClick={handleBack} className="mb-4">
        <ArrowLeft className="mr-2 h-4 w-4" />
        {t('legal.backToApp')}
      </Button>

      <Card>
        <CardHeader>
          <CardTitle>
            <h2 className="text-2xl font-bold">{t(titleKey)}</h2>
          </CardTitle>
          <p className="text-sm text-muted-foreground">{t('legal.lastUpdated')}</p>
        </CardHeader>
        <CardContent className="prose dark:prose-invert max-w-none space-y-6">
          {children}
        </CardContent>
      </Card>
    </article>
  );
}

interface LegalSectionProps {
  titleKey: string;
  children: ReactNode;
}

export function LegalSection({ titleKey, children }: Readonly<LegalSectionProps>) {
  const { t } = useTranslation();

  return (
    <section>
      <h3 className="text-lg font-semibold">{t(titleKey)}</h3>
      {children}
    </section>
  );
}
